import { Button, makeStyles } from '@material-ui/core'
import CameraAltIcon from '@material-ui/icons/CameraAlt'
import React, { useCallback, useContext, useState } from 'react'
import Modal from '../../components/Modal'
import MobileCamera from './MobileCamera'
import SearchForm from './SearchForm'
import MaterialBatchImage from '../../images/materialbatch.png'
import { useTranslation } from 'react-i18next'

type ReturnSearchContextState = {
    material: string,
    setMaterial: React.Dispatch<string>
    batch: string,
    setBatch: React.Dispatch<string>
    quantity: number,
    setQuantity: React.Dispatch<number>
    displayBarcodeHelp: boolean
    setDisplayBarcodeHelp: React.Dispatch<boolean>
    resetSearch: () => void
}

export const ReturnSearchContext = React.createContext<ReturnSearchContextState>({} as ReturnSearchContextState)

const ReturnSearchContextProvider: React.FC = (props) => {
    const [material, setMaterial] = useState<string>('')
    const [batch, setBatch] = useState<string>('')
    const [quantity, setQuantity] = useState<number>(1)
    const [displayBarcodeHelp, setDisplayBarcodeHelp] = useState<boolean>(false)
    const { t } = useTranslation()

    const resetSearch = useCallback(() => {
        setMaterial('')
        setBatch('')
        setQuantity(1)
    }, [])

    return <ReturnSearchContext.Provider value={{
        material,
        setMaterial,
        batch,
        setBatch,
        quantity,
        setQuantity,
        displayBarcodeHelp,
        setDisplayBarcodeHelp,
        resetSearch,
    }}>
        <Modal name='product-lookup' title={t('find_material_lot')} open={displayBarcodeHelp} onClose={() => setDisplayBarcodeHelp(false)}>
            <div style={{ marginBottom: 15 }}>
                <img src={MaterialBatchImage} alt="" style={{ width: '100%' }} />
            </div>
        </Modal>
        {props.children}
    </ReturnSearchContext.Provider>
}

const useStyles = makeStyles(() => ({
    scanOption: {
        width: '100%',
        height: '3rem'
    }
}))

export const CameraScannerButton = () => {
    const classes = useStyles()
    const { setMaterial, setBatch } = useContext(ReturnSearchContext)
    const [displayCameraScanner, setDisplayCameraScanner] = useState<boolean>(false)
    const { t } = useTranslation()

    const onData = useCallback((d: Record<string, string>) => {
        setMaterial(d['240'])
        setBatch(d['10'])
        setDisplayCameraScanner(false)
    }, [setBatch, setMaterial])

    return (
        <>
            {displayCameraScanner && <MobileCamera onData={onData} onClose={() => setDisplayCameraScanner(false)} />}

            <Button
                className={classes.scanOption}
                onClick={() => setDisplayCameraScanner(true)}
                startIcon={<CameraAltIcon />}
                color="secondary"
                variant='outlined'
            >
                {t('scan_with_camera')}
            </Button>
        </>
    )
}

const ReturnSearch: React.FC = () => {
    return (
        <ReturnSearchContextProvider>
            <SearchForm />
        </ReturnSearchContextProvider>
    )
}

export default ReturnSearch
